export const createAccountFormCopy = {
  title: "Create your account",
  accountPrompt: "Already have an account?",
  loginLink: "Login",
  firstNameLabel: "First Name",
  firstNamePlaceholder: "Jane",
  lastNameLabel: "Last Name",
  lastNamePlaceholder: "Doe",
  emailLabel: "Professional Email",
  emailPlaceholder: "jane.doe@school.edu",
  passwordLabel: "Password",
  passwordPlaceholder: "Create a password",
  submitLabel: "Create Account",
  submittingLabel: "Creating account…",
  orContinueWith: "Or continue with",
  loginButton: "Login",
  footerPrefix: "By creating an account, you agree to our",
  termsLabel: "Terms of Service",
  privacyLabel: "Privacy Policy",
  unavailableMessage:
    "Account registration is not available yet. Please sign in with an existing account or launch ITEMA from TutorCloud.",
};

export const passwordRequirementLabels = {
  minLength: "At least 8 characters",
  hasNumber: "Contains a number",
  hasSpecial: "Contains a special character",
  hasUppercase: "Includes uppercase letter",
};
